module.exports = __webpack_public_path__ + "static/media/bg.b5d11e40.png";